import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { AuditLogViewer } from "@/features/admin/components/audit-log-viewer";
import { PageContainer } from "@/components/ui/page-container";

/** URL-addressable audit-log filters (`?entityType=&action=&userId=&page=`). */
interface AdminAuditSearch {
  entityType?: string;
  action?: string;
  userId?: string;
  page?: number;
}

function AdminAuditPage() {
  return (
    <PageContainer maxWidth="6xl">
      <AuditLogViewer />
    </PageContainer>
  );
}

export const adminAuditRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/audit",
  validateSearch: (search: Record<string, unknown>): AdminAuditSearch => {
    const out: AdminAuditSearch = {};
    if (typeof search.entityType === "string" && search.entityType.trim() !== "") {
      out.entityType = search.entityType;
    }
    if (typeof search.action === "string" && search.action.trim() !== "") {
      out.action = search.action;
    }
    if (typeof search.userId === "string" && search.userId.trim() !== "") {
      out.userId = search.userId;
    }
    const page = Number(search.page);
    if (Number.isFinite(page) && page > 1) {
      out.page = Math.floor(page);
    }
    return out;
  },
  component: AdminAuditPage,
});
